import _ from 'lodash';
import { setLocationDetails } from '../../store/features/system';
const TIMEOUT_DELAY = 5000;

const defaultLocationDetails = {
  clientIp: null,
  location: {
    country_code: null,
    country_name: null,
    region_name: null,
    city: null,
    latitude: null,
    longitude: null,
    asn: null,
    isp: null,
  },
};

const defaultClientIp = {
  clientIp: null,
};

const getPromiseWithTimeout = (promise, delay, defaultValue) => {
  let timeout;
  const timeoutPromise = new Promise((resolve) => {
    timeout = setTimeout(() => {
      resolve(defaultValue);
    }, delay);
  });

  return Promise.race([promise, timeoutPromise]).then((info) => {
    clearTimeout(timeout);
    return info;
  });
};

export default angular
  .module('doxy.common.services.userLocationDetails', [])
  .factory('UserLocationDetails', function ($q, User, $ngRedux) {
    function ipType(ip) {
      if (ip.match(/^(192\.168\.|169\.254\.|10\.|172\.(1[6-9]|2\d|3[01]))/)) {
        return 'local';
      } else if (ip.match(/^[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7}$/)) {
        return 'IPv6';
      }

      return 'IPv4';
    }

    //get the IP addresses associated with an account
    let ips = [];

    let clientIp = null;
    let locationDetails = null;

    return {
      getIPs() {
        if (ips.length) return $q.resolve(ips);
        const defer = $q.defer();
        User.getClientIp((ipInfo) => {
          ips.push(ipInfo.clientIp);
          defer.resolve(ips);
        });
        return defer.promise;
      },

      pickPreferable: function pickPreferable(ips, order) {
        const preferred = order.shift();
        const found = _.find(ips, function (ip) {
          return ipType(ip) === preferred;
        });

        return found || (order.length ? pickPreferable(ips, order) : ips[0]);
      },

      getClientIP(shouldRefetch) {
        if (!clientIp || shouldRefetch) {
          clientIp = getPromiseWithTimeout(
            User.getClientIp().$promise,
            TIMEOUT_DELAY,
            defaultClientIp
          )
            .then((info) => info.clientIp)
            .catch((_err) => defaultClientIp);
        }
        return clientIp;
      },
      getLocationDetails(shouldRefetch) {
        if (!locationDetails || shouldRefetch) {
          locationDetails = getPromiseWithTimeout(
            User.getLocationDetails().$promise,
            TIMEOUT_DELAY,
            defaultLocationDetails
          )
            .then((info) => info)
            .catch((_err) => defaultLocationDetails)
            .then((info) => {
              $ngRedux.dispatch(setLocationDetails(info));
              return info;
            });
        }
        return locationDetails;
      },
    };
  }).name;
